import type { Core } from '@strapi/types';

export default async ({ strapi }: { strapi: Core.Strapi }) => {};
